export default (...fns) =>
  (val) =>
    fns.reduce((res, fn) => fn(res), val);
